import { useUploadImage } from 'libs/hooks/io/useUploadImage';
import { EUploadResolution } from 'libs/utils/logic/operations/fileOperations';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ImageUploaderPage = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const { inProgress, uploaded, setFiles } = useUploadImage(
        [EUploadResolution.ULTRA],
        ctxEdit.map?.worldMapId
    );
    const [urls, setUrls] = useState<string[]>([]);

    useEffect(() => {
        if (uploaded?.data?.imageUrls) {
            const url = uploaded?.data?.imageUrls?.[EUploadResolution.ULTRA];
            setUrls([...urls, url]);
        }
    }, [uploaded]);

    return (
        <S_ImageUploaderPage className={props.className}>
            {inProgress === 0 && (
                <S_InputFile
                    multiple
                    type="file"
                    accept="image/x-png,image/png,image/gif,image/jpeg,image/jpg,image/heic,image/heif,image/svg+xml,.heic;capture=camera"
                    onChange={(e) => setFiles(Array.from(e.target['files']))}
                />
            )}
            {inProgress > 0 && <span>In progress: {inProgress}</span>}
            <S_Uploaded>
                {urls.map((url) => {
                    return (
                        <a href={url} target="_blank" key={url} rel="noreferrer">
                            {url}
                        </a>
                    );
                })}
            </S_Uploaded>
        </S_ImageUploaderPage>
    );
};

const S_ImageUploaderPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;

const S_Uploaded = styled.div`
    display: flex;
    flex-direction: column;
`;

const S_InputFile = styled.input``;
